module.exports = __webpack_public_path__ + "img/figuurc02.77ce8a3d.png";